<template>
  <div>
    <!-- 插件信息列表 -->
    <el-table :data="list.value" :span-method="arraySpanMethod" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="pluginCode" label="插件ID"></el-table-column>
      <el-table-column prop="name" label="策略名称"></el-table-column>
      <el-table-column prop="priority" label="优先级"></el-table-column>
      <el-table-column prop="createUser" label="上传人/时间">
        <template slot-scope="scope">
          <span>{{ scope.row.appPlugin.createUser }}</span>&nbsp;<span>{{ scope.row.appPlugin.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateUser" label="更新人/时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateUser }}</span>&nbsp;<span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <!-- 0起草中 1已上架 2已下架 3已禁用 -->
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">起草中</span>
          <span v-if="scope.row.status === 1">已上架</span>
          <span v-if="scope.row.status === 2">已下架</span>
          <span v-if="scope.row.status === 3">已禁用</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_EDIT'" type="text" size="small"
            @click="edit(scope.row)">修改</el-button>
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_ON'" type="text" size="small"
            @click="putOn(scope.row.id)">发布</el-button>
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_OFF'" type="text" size="small"
            @click="putOff(scope.row.id)">下架</el-button>
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_DISABLE'" type="text" size="small"
            @click="disable(scope.row.id)">禁用</el-button>
          <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_TACTICS_DEL'" type="text" size="small"
            @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px" :total="searchParams.total" :current="searchParams.current"
      :size="searchParams.size" :pageSizes="[10, 20, 100]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
    <Add ref="addDialog" />
  </div>
</template>

<script>
import { deletePluginsTactics, disablePluginsTactics, offlinePluginsTactics, onlinePluginsTactics } from "@/api/pluginManage/pluginTactics";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import { handleEditFormData } from '../utils/index';
import Add from "./add.vue";
export default {
  name: "WebSaaSTable",
  inject: ["searchParams", "list", "loadList"],
  components: {
    ElementPagination,
    Add
  },
  data() {
    return {};
  },
  computed: {
    rowSpanInfo() {
      return {};
    }
  },
  methods: {
    arraySpanMethod({ row, _, rowIndex, columnIndex }) {
      // 插件ID和策略名称列
      if (columnIndex === 0 || columnIndex === 1) {
        // 同时合并第1列（插件ID）和第2列（策略名称）
        if (rowIndex === 0) {
          // 缓存当前行的合并信息
          this.cacheRowSpan(row, rowIndex);
          return this.rowSpanInfo[rowIndex];
        }
        // 如果当前行的插件ID与上一行相同，则隐藏当前行的单元格
        if (row.pluginCode === this.list.value[rowIndex - 1].pluginCode) {
          return [0, 0];
        } else {
          // 如果不相同，重新计算合并行数
          this.cacheRowSpan(row, rowIndex);
          return this.rowSpanInfo[rowIndex];
        }
      }
      // 其他列不合并
      return [1, 1];
    },

    cacheRowSpan(row, rowIndex) {
      let rowSpan = 1;
      // 从当前行开始，向下查找相同插件ID的连续行数
      for (let i = rowIndex + 1; i < this.list.value.length; i++) {
        if (this.list.value[i].pluginCode === row.pluginCode) {
          rowSpan++;
        } else {
          break;
        }
      }
      // 存储合并信息
      this.rowSpanInfo[rowIndex] = [rowSpan, 1];
    },
    //^ ^--------------表格操作栏内的事件-------------^ ^
    /** 修改 */
    edit(row) {
      console.log('row', row);
      const { params, channelInfo } = handleEditFormData(row)
      this.$refs.addDialog.show(params, channelInfo)
    },
    /** 发布 */
    async putOn(id) {
      /** 二次确认 */
      this.$confirm("此操作将发布该策略, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await onlinePluginsTactics(id);
          console.log("发布的响应", data);
          if (data.code === 200) {
            Message.success("发布成功");
            this.loadList();
          }
        })
        .catch(() => {
          console.log("取消发布");
        });
    },
    /** 下架 */
    async putOff(id) {
      /** 二次确认 */
      this.$confirm("此操作将下架该策略, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await offlinePluginsTactics(id);
          console.log("下架的响应", data);
          if (data.code === 200) {
            Message.success("下架成功");
            this.loadList();
          }
        })
        .catch(() => {
          console.log("取消下架");
        });
    },
    /** 禁用 */
    async disable(id) {
      /** 二次确认 */
      this.$confirm("此操作将禁用该策略, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await disablePluginsTactics(id);
          console.log("禁用的响应", data);
          if (data.code === 200) {
            Message.success("禁用成功");
            this.loadList();
          }
        })
        .catch(() => {
          console.log("取消禁用");
        });
    },
    /** 删除 */
    del(id) {
      this.$confirm("此操作将永久删除该策略, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await deletePluginsTactics(id);
          if (data.code === 200) {
            Message.success("删除成功");
            this.loadList();
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
